import React, { useState, useLayoutEffect } from 'react';
var HEIGHT_RATIO = 3.375;

var getImage = function getImage() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-us';
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale;
  return {
    ios: 'https://linkmaker.itunes.apple.com/images/badges/' + locale + '/badge_appstore-lrg.svg',
    android: 'https://raw.github.com/yjb94/google-play-badge-svg/master/img/' + code + '_get.svg?sanitize=true'
  };
};

var ReactStoreBadges = function ReactStoreBadges(_ref) {
  var url = _ref.url,
      _ref$defaultLocale = _ref.defaultLocale,
      defaultLocale = _ref$defaultLocale === undefined ? 'en-us' : _ref$defaultLocale,
      platform = _ref.platform,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? typeof navigator !== 'undefined' && navigator.language || defaultLocale : _ref$locale,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 135 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? width / HEIGHT_RATIO : _ref$height,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? "_self" : _ref$target;
  var shortCode = locale = locale.toLowerCase();
  var expeptionLocale = ["zh-cn", "zh-tw"];

  if (expeptionLocale.indexOf(locale) === -1) {
    shortCode = locale.split(/[_-]/)[0];
  }

  var _useState = useState(getImage(locale, shortCode)),
      image = _useState[0],
      setImage = _useState[1];

  var setDefaultImage = function setDefaultImage() {
    setImage(getImage(defaultLocale, shortCode));
  };

  useLayoutEffect(function () {
    setImage(getImage(locale, shortCode));
  }, [locale]);
  return /*#__PURE__*/React.createElement('a', {
    style: {
      display: 'inline-block',
      height: height,
      width: width
    },
    href: url,
    target: target
  }, /*#__PURE__*/React.createElement('img', {
    src: image[platform],
    style: {
      width: '100%',
      height: '100%'
    },
    onError: setDefaultImage
  }));
};

export default ReactStoreBadges;